export default function Buisness () {
    return (
        <div style={{margin: "auto"}}>
            <h1 style={{color: "black", textAlign: "center"}}> Buisness</h1>
        </div>
    )
}